// extracted by mini-css-extract-plugin
export default {"emote":"ELy8P","not-official":"MzKoD","notOfficial":"MzKoD","title":"zT--V","emote-pixel":"_3P6TU","emotePixel":"_3P6TU"};